import React from "react";

import DashboardShell from "../dashboard/DashboardShell";

const Content = () => (
  <DashboardShell
    title="Cities"
    subtitle="Content footprint across every city in the platform."
    clickRoute="/cities"
    breadCrumbDefault={false}
  />
);

export default Content;
